"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Toggle = function (_a) {
    var className = _a.className, value = _a.value, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return react_1.default.createElement("button", { disabled: disabled, className: "storybook-forms-toggle" + (value ? '-active' : '') + " " + className, onClick: onClick },
        react_1.default.createElement("span", { className: 'sr-only' }, "Use setting"),
        react_1.default.createElement("span", { "aria-hidden": 'true', className: 'storybook-forms-toggle-handle' }));
};
exports.Toggle = Toggle;
exports.Toggle.propTypes = {
    value: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
};
exports.Toggle.defaultProps = {
    value: false,
};
